import Price from "./Price";
import './Price.css';

export default Price